import React, { useEffect } from "react";
import styles from "./ThemeToggle.module.css";

const ThemeToggle = ({ theme, setTheme }) => {
    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        setTheme(newTheme);
        localStorage.setItem("theme", newTheme);
    };

    useEffect(() => {
        document.body.classList.toggle("dark", theme === "dark");
    }, [theme]);

    return (
        <button
            className={styles.button}
            onClick={toggleTheme}
            title="Сменить тему"
        >
            <img
                src={theme === "light" ? "/sun.png" : "/moon.png"}
                alt="Сменить тему"
                className={styles.image}
            />
        </button>
    );
};

export default ThemeToggle;